import React, { Component } from 'react';

import SearchFilters from './SearchFilters';

import Navbar, { Logo } from '../styles/Navbar';
import { ToggleButton } from '../styles/Button';
import { Button } from '../styles/Button';
import logo from '../assets/logo-dtn.svg';

class LeftArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            width: "auto",
        };
    }

    toggleVisibility = () => {
        const visible = !this.state.visible;
        const width = visible ? 'auto' : '50px';
        this.setState({
            visible: visible,
            width: width,
        });
    };

    render() {
        return (
            <Navbar full={this.state.visible}>
                <Logo>
                    <span>
                        <img src={logo} className={"logo"} alt={"logo"}/>
                        Model Inventory
                    </span>
                </Logo>
                <Button onClick={() => {window.open("https://dtnse1.atlassian.net/wiki/spaces/MDS/pages/35702048869/FAQ+-+Model+Data+Inventory");}}>Frequently Asked Questions</Button>
                <Button onClick={() => {window.open("https://dtnse1.atlassian.net/wiki/spaces/MDS/pages/36530520188/Support");}}>Support/ Runbooks</Button>
                <Button onClick={() => {window.open("https://www.dtn.com/do-not-sell-my-information-form/");}}>Do Not Sell My Personal Information</Button>
                <ToggleButton onClick={this.toggleVisibility}>Toggle Filters</ToggleButton>
                <SearchFilters {...this.props} visible={this.state.visible} />
                <footer>
                    Copyright © {new Date().getFullYear()} DTN, Inc.
                </footer>
            </Navbar>
        );
    }
}

export default LeftArea;



// WEBPACK FOOTER //
// ./src/components/LeftArea.js